import { mapValues } from "lodash";

export interface DateOnly {
  year: number;
  month: number;
  day: number;
}

export function dateOnlyToString(date: DateOnly | undefined): string | undefined {
  if (!date) {
    return undefined;
  }
  return [
    String(date.year).padStart(4, "0"),
    String(date.month).padStart(2, "0"),
    String(date.day).padStart(2, "0"),
  ].join("-");
}

const datePatterns = [
  /^(?<year>[12][0-9]{3})[^0-9](?<month>[012]?[0-9])[^0-9](?<day>[0123]?[0-9])$/,
  /^(?<day>[0123]?[0-9])[^0-9](?<month>[012]?[0-9])[^0-9](?<year>[12][0-9]{3})$/,
];
export function stringToDateOnly(date: string): DateOnly {
  return (
    datePatterns
      .map((p) => p.exec(date)?.groups)
      .filter((it) => it)
      .map((it) => mapValues(it, (it) => Number(it)) as unknown as DateOnly)[0] ?? { year: 0, month: 0, day: 0 }
  );
}
